import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import ContentHeader from '../../Layout/ContentHeader'
import LayoutTable from '../../Global/LayoutTable'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import {
  DELETE_CONFIG_APP_PAGES,
  GET_ALL_CONFIG_APP_PAGES,
} from '../../../graphql/ConfigApp/configAppPages'
import { useHistory } from 'react-router-dom'

const ConfigAppPages = () => {
  const history = useHistory()
  console.log('history', history)

  //STATES:
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])

  //QUERIES:
  const { loading, error, data } = useQuery(GET_ALL_CONFIG_APP_PAGES, {
    variables: { ...pagePagination },
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllConfigAppPages?.rows.map((item) => {
        let colorVisible = item.visible ? 'text-success' : 'text-gray'
        const divVisible = (
          <i className={`fas fa-check-circle ${colorVisible} fa-2x`} />
        )

        return list.push({
          id: item.id,
          nombre: item.name,
          descripcion: item.description,
          visible: divVisible,
          elementos: item?.ElementsOfPage.length,
        })
      })
      setDataToTable(list)
      setTotal(data.getAllConfigAppPages?.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  return (
    <>
      <ContentHeader
        title="Configuraciones APP"
        breadcrumb=""
        windowTitle="Configuracion App"
      />
      <LayoutTable
        title="Lista de paginas"
        data={dataToTable}
        gql={DELETE_CONFIG_APP_PAGES}
        requery={GET_ALL_CONFIG_APP_PAGES}
        exportImportButton={false}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        FilterBarPlaceholder="Buscar por nombre"
        hideDetails
      />
    </>
  )
}

export default ConfigAppPages
